import React from 'react'
import Manager from '../../public/components/Manager'
import SealInformation from './SealInformation'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        { icon: 'plus', text: '添加印章 ...', handler: ({ showDetail }) => showDetail(SealInformation) },
      ],
    columns: [
        { _text: '印章名称', field: 'Name', minWidth: 150, flex: 2, search: true },
        { _text: '保管人', field: 'PersonName', minWidth: 150, flex: 2, filter: true },
        { _text: '用途说明', field: 'Remark', minWidth: 150, flex: 2 },
        { _text: '被授权人', field: '_Licensee', minWidth: 150, flex: 2 },
        { _text: '被授权时间', field: '_AuthorizedTime', minWidth: 150, flex: 2 },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <SealInformation {...props} id={data.id} />)
    }
}

export default props => <Manager {...props} config={config} />